import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class DeleteCampaignApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/campaignBundle/deleteCampaign',
      requesterInfo,
    })
  }

  public async deleteCampaign(request: number[]): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
